/* unplugin-vue-components disabled */import script from "./RecruitStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitStudent.vue?vue&type=script&setup=true&lang=js"

import "./RecruitStudent.vue?vue&type=style&index=0&id=4c14c4b1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c14c4b1"]])

export default __exports__